import Cookies from "js-cookie";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST } from "../../../utils/Methods";
import { APIS } from "../../../utils/APIS";
import { IDS } from "../../../utils/IDS";

// 🔹 SIGNUP
export const CreateCustomerSignup = createAsyncThunk(
  "/customer-signup",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.CreateCustomerSignup, data);

      if (res?.success && res?.data?.token) {
        Cookies.set("spirulina_website_security", res.data.token, {
          expires: 7,
          secure: true,
          sameSite: "strict",
        });
      }

      return res;
    } catch (error) {
      console.error("Signup API error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const sendLoginOtp = createAsyncThunk(
  "/sendLoginOtp",
  async (data, { rejectWithValue }) => {
    try {
      const otp = await POST(APIS.Auth.sendLoginOtp, data);

      if (otp?.success === false) {
        return rejectWithValue(otp);
      }

      return otp;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const LoginverifyOtp = createAsyncThunk(
  "/verify_otp",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.LoginverifyOtp, data);

      if (res?.success === false) {
        return rejectWithValue(res);
      }

      if (res?.success && res?.data?.token) {


        Cookies.set("spirulina_website_security", res.data.token, {
          expires: 7,
        });
      }

      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const GETProfile = createAsyncThunk(
  "/user/profile",
  async (_, { rejectWithValue }) => {
    try {
      const token = Cookies.get("spirulina_website_security");

      const res = await GET(APIS.Auth.GETProfile, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });


      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const Update_Profile = createAsyncThunk(
  "/user/profiles",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.Auth.Update_Profile, data);

      if (response?.success) {
        return response;
      }

      return rejectWithValue(response?.message || "Request failed");
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error.message || "Server error",
      );
    }
  },
);

export const GETLevel = createAsyncThunk(
  "/master/levels",
  async (_, { rejectWithValue }) => {
    try {
      const token = Cookies.get("spirulina_website_security");

      const res = await GET(APIS.Auth.GETLevel, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const GETLevelDetails = createAsyncThunk(
  "/master/levelsdetails",
  async ({ search = "", level_id = "" }, { rejectWithValue }) => {
    try {
      const token = Cookies.get("spirulina_website_security");

      const res = await GET(
        `${APIS.Auth.GETLevelDeatils}?search=${search}&level_id=${level_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);
export const GetUserLevelDetails = createAsyncThunk(
  "/master/LevelRank",
  async (_, { rejectWithValue }) => {
    try {
      const token = Cookies.get("spirulina_website_security");

      const res = await GET(APIS.Auth.GetUserLevelDetails, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const GetTeamDetails = createAsyncThunk(
  "/team-details",
  async (search = "", { rejectWithValue }) => {
    try {
      const token = Cookies.get("spirulina_website_security");

      const res = await GET(APIS.Auth.GetTeamDetails, {
        params: {
          search: search,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);
export const GetUserNotification = createAsyncThunk(
  "/getnotification",
  async (search = "", { rejectWithValue }) => {
    try {
      const token = Cookies.get("spirulina_website_security");

      const res = await GET(
        `${APIS.Auth.GetUserNotification}?search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );


      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const GetUserTransaction = createAsyncThunk(
  "/master/wallet",
  async (search = "", { rejectWithValue }) => {
    try {
      const token = Cookies.get("spirulina_website_security");

      const res = await GET(
        `${APIS.Auth.GetUserTransaction}?search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );


      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const sendMobileOtp = createAsyncThunk(
  "/send-otp",
  async (data, { rejectWithValue }) => {
    try {
      const otp = await POST(APIS.Auth.SEND_OTP, data);

      if (otp?.success === false) {
        return rejectWithValue(otp);
      }

      return otp;
    } catch (error) {
      // 🔴 Extract backend response message
      return rejectWithValue(
        error?.response?.data || { message: "Something went wrong" },
      );
    }
  },
);

export const verifyOtp = createAsyncThunk(
  "/otp-verify",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.Auth.VERIFY_OTP, data);


      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Something went wrong" },
      );
    }
  },
);

export const createSignup = createAsyncThunk(
  "/signup",
  async (data, { rejectWithValue }) => {
    try {
      const otp = await POST(APIS.Auth.Sign_Up, data);

      if (otp?.success === false) {
        return rejectWithValue(otp);
      }

      return otp;
    } catch (error) {
      // 🔴 Extract backend response message
      return rejectWithValue(
        error?.response?.data || { message: "Something went wrong" },
      );
    }
  },
);

export const customerLogin = createAsyncThunk(
  "/login",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.Customer_Login, data);

      if (res?.success === false) {
        return rejectWithValue(res);
      }

      if (res?.success && res?.data?.token) {

        Cookies.set("spirulina_website_security", res.data.token, {
          expires: 7,
        });
      }

      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

// export const getUserWalletHistory = createAsyncThunk(
//   "/wallet_history",
//   async (data, { rejectWithValue }) => {
//     try {
//       const otp = await POST(APIS.Auth.getUserWalletHistory, data);

//       if (otp?.success === false) {
//         return rejectWithValue(otp);
//       }

//       return otp;
//     } catch (error) {
//       // 🔴 Extract backend response message
//       return rejectWithValue(
//         error?.response?.data || { message: "Something went wrong" },
//       );
//     }
//   },
// );

export const getUserWalletHistory = createAsyncThunk(
  "/wallet_history",
  async (search = "", { rejectWithValue }) => {
    try {
      const token = Cookies.get("spirulina_website_security");

      const res = await GET(`${APIS.Auth.getUserWalletHistory}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const getUserIncomeDetails = createAsyncThunk(
  "/userIncomeDetailsy",
  async (id = "", { rejectWithValue }) => {
    try {
      const token = Cookies.get("spirulina_website_security");

      const res = await GET(`${APIS.Auth.getUserIncomeDetails}?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const forgotPassword = createAsyncThunk(
  "/updatePassword",
  async (data, { rejectWithValue }) => {
    try {
      const otp = await POST(APIS.Auth.forgotPassword, data);

      if (otp?.success === false) {
        return rejectWithValue(otp);
      }

      return otp;
    } catch (error) {
      // 🔴 Extract backend response message
      return rejectWithValue(
        error?.response?.data || { message: "Something went wrong" },
      );
    }
  },
);

export const LoginSlice = createSlice({
  name: "login",
  initialState: {
    loginData: null,
    loginStatus: IDS.SLICESTATUS.Idle,
    loginError: null,

    signupData: null,
    signupStatus: IDS.SLICESTATUS.Idle,
    signupError: null,

    sendOtpData: null,
    sendOtpStatus: IDS.SLICESTATUS.Idle,
    sendOtpError: null,

    verifyOtpData: null,
    verifyOtpStatus: IDS.SLICESTATUS.Idle,
    verifyOtpError: null,

    createSignupData: null,
    createSignupStatus: IDS.SLICESTATUS.Idle,
    createSignupError: null,

    customerLoginData: null,
    customerLoginStatus: IDS.SLICESTATUS.Idle,
    customerLoginError: null,

    forgotPasswordData: null,
    forgotPasswordStatus: IDS.SLICESTATUS.Idle,
    forgotPasswordError: null,

    sendLoginOtpData: null,
    sendLoginOtpStatus: IDS.SLICESTATUS.Idle,
    sendLoginOtpError: null,

    verifyLoginOtpData: null,
    verifyLoginOtpStatus: IDS.SLICESTATUS.Idle,
    verifyLoginOtpError: null,

    getCustomerData: null,
    getCustomerStatus: IDS.SLICESTATUS.Idle,
    getCustomerError: null,

    updateCustomerStatus: IDS.SLICESTATUS.Idle,
    updateCustomerError: null,

    getLevelData: [],
    getLevelStatus: IDS.SLICESTATUS.Idle,
    getLevelError: null,

    getLeveldetailsData: [],
    getLeveldetailsStatus: IDS.SLICESTATUS.Idle,
    getLeveldetailsError: null,

    getUserLevelData: [],
    getUserLevelStatus: IDS.SLICESTATUS.Idle,
    getUserLevelError: null,

    getUserTeamDetailsData: [],
    getUserTeamDetailsStatus: IDS.SLICESTATUS.Idle,
    getUserTeamDetailsError: null,

    getUserNotificationData: [],
    getUserNotificationStatus: IDS.SLICESTATUS.Idle,
    getUserNotificationError: null,

    getUserTransactionData: [],
    getUserTransactionStatus: IDS.SLICESTATUS.Idle,
    getUserTransactionError: null,

    getUserWalletHistoryData: null,
    getUserWalletHistoryStatus: IDS.SLICESTATUS.Idle,
    getUserWalletHistoryError: null,

    getUserIncomeDetailsData: null,
    getUserIncomeDetailsStatus: IDS.SLICESTATUS.Idle,
    getUserIncomeDetailsError: null,
  },
  reducers: {
    logoutUser: (state) => {
      Cookies.remove("spirulina_website_security");

      state.loginData = null;
      state.signupData = null;
      state.loginStatus = IDS.SLICESTATUS.Idle;
      state.signupStatus = IDS.SLICESTATUS.Idle;
    },
  },
  extraReducers: (builder) => {
    builder

      // 🔹 SIGNUP
      .addCase(CreateCustomerSignup.pending, (state) => {
        state.signupStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateCustomerSignup.fulfilled, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Succeeded;
        state.signupResponse = action.payload;
      })
      .addCase(CreateCustomerSignup.rejected, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Failed;
        state.signupError = action.payload;
      })

      .addCase(sendLoginOtp.pending, (state) => {
        state.sendLoginOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(sendLoginOtp.fulfilled, (state, action) => {
        state.sendLoginOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.sendLoginOtpData = action.payload?.data || null;
      })
      .addCase(sendLoginOtp.rejected, (state, action) => {
        state.sendLoginOtpStatus = IDS.SLICESTATUS.Failed;
        state.sendLoginOtpError = action.payload;
      })

      .addCase(LoginverifyOtp.pending, (state) => {
        state.verifyLoginOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(LoginverifyOtp.fulfilled, (state, action) => {
        state.verifyLoginOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.verifyLoginOtpData = action.payload?.data || null;
      })
      .addCase(LoginverifyOtp.rejected, (state, action) => {
        state.verifyLoginOtpStatus = IDS.SLICESTATUS.Failed;
        state.verifyLoginOtpError = action.payload;
      })

      .addCase(GETProfile.pending, (state) => {
        state.getCustomerStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(GETProfile.fulfilled, (state, action) => {
        state.getCustomerStatus = IDS.SLICESTATUS.Succeeded;
        state.getCustomerData = action.payload?.data || null;
      })
      .addCase(GETProfile.rejected, (state, action) => {
        state.getCustomerStatus = IDS.SLICESTATUS.Failed;
        state.getCustomerError = action.payload;
      })

      .addCase(Update_Profile.pending, (state) => {
        state.updateCustomerStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update_Profile.fulfilled, (state, action) => {
        state.updateCustomerStatus = IDS.SLICESTATUS.Succeeded;
        state.getCustomerData = {
          ...state.getCustomerData,
          ...action.payload?.data,
        };
      })
      .addCase(Update_Profile.rejected, (state, action) => {
        state.updateCustomerStatus = IDS.SLICESTATUS.Failed;
        state.updateCustomerError = action.payload;
      })

      .addCase(GETLevel.pending, (state) => {
        state.getLevelStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(GETLevel.fulfilled, (state, action) => {
        state.getLevelStatus = IDS.SLICESTATUS.Succeeded;
        state.getLevelData = action.payload?.data || null;
      })
      .addCase(GETLevel.rejected, (state, action) => {
        state.getLevelStatus = IDS.SLICESTATUS.Failed;
        state.getLevelError = action.payload;
      })

      .addCase(GETLevelDetails.pending, (state) => {
        state.getLeveldetailsStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(GETLevelDetails.fulfilled, (state, action) => {
        state.getLeveldetailsStatus = IDS.SLICESTATUS.Succeeded;
        state.getLeveldetailsData = action.payload?.data || null;
      })
      .addCase(GETLevelDetails.rejected, (state, action) => {
        state.getLeveldetailsStatus = IDS.SLICESTATUS.Failed;
        state.getLeveldetailsError = action.payload;
      })

      .addCase(GetUserLevelDetails.pending, (state) => {
        state.getUserLevelStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetUserLevelDetails.fulfilled, (state, action) => {
        state.getUserLevelStatus = IDS.SLICESTATUS.Succeeded;
        state.getUserLevelData = action.payload?.data || null;
      })
      .addCase(GetUserLevelDetails.rejected, (state, action) => {
        state.getUserLevelStatus = IDS.SLICESTATUS.Failed;
        state.getUserLevelError = action.payload;
      })

      .addCase(GetTeamDetails.pending, (state) => {
        state.getUserTeamDetailsStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetTeamDetails.fulfilled, (state, action) => {
        state.getUserTeamDetailsStatus = IDS.SLICESTATUS.Succeeded;
        state.getUserTeamDetailsData = action.payload?.data || null;
      })
      .addCase(GetTeamDetails.rejected, (state, action) => {
        state.getUserTeamDetailsStatus = IDS.SLICESTATUS.Failed;
        state.getUserTeamDetailsError = action.payload;
      })


      .addCase(GetUserNotification.pending, (state) => {
        state.getUserNotificationStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetUserNotification.fulfilled, (state, action) => {
        state.getUserNotificationStatus = IDS.SLICESTATUS.Succeeded;
        state.getUserNotificationData = action.payload?.data || null;
      })
      .addCase(GetUserNotification.rejected, (state, action) => {
        state.getUserNotificationStatus = IDS.SLICESTATUS.Failed;
        state.getUserNotificationError = action.payload;
      })

      .addCase(GetUserTransaction.pending, (state) => {
        state.getUserTransactionStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetUserTransaction.fulfilled, (state, action) => {
        state.getUserTransactionStatus = IDS.SLICESTATUS.Succeeded;
        state.getUserTransactionData = action.payload?.data || null;
      })
      .addCase(GetUserTransaction.rejected, (state, action) => {
        state.getUserTransactionStatus = IDS.SLICESTATUS.Failed;
        state.getUserTransactionError = action.payload;
      })

      .addCase(sendMobileOtp.pending, (state) => {
        state.sendOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(sendMobileOtp.fulfilled, (state, action) => {
        state.sendOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.sendOtpData = action.payload?.data || null;
      })
      .addCase(sendMobileOtp.rejected, (state, action) => {
        state.sendOtpStatus = IDS.SLICESTATUS.Failed;
        state.sendOtpError = action.payload;
      })

      .addCase(verifyOtp.pending, (state) => {
        state.verifyOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.verifyOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.verifyOtpData = action.payload?.data || null;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.verifyOtpStatus = IDS.SLICESTATUS.Failed;
        state.verifyOtpError = action.payload?.message || action.payload;
      })

      .addCase(createSignup.pending, (state) => {
        state.createSignupStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(createSignup.fulfilled, (state, action) => {
        state.createSignupStatus = IDS.SLICESTATUS.Succeeded;
        state.createSignupData = action.payload?.data || null;
      })
      .addCase(createSignup.rejected, (state, action) => {
        state.createSignupStatus = IDS.SLICESTATUS.Failed;
        state.createSignupError = action.payload;
      })

      .addCase(customerLogin.pending, (state) => {
        state.customerLoginStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(customerLogin.fulfilled, (state, action) => {
        state.customerLoginStatus = IDS.SLICESTATUS.Succeeded;
        state.customerLoginData = action.payload?.data || null;
      })
      .addCase(customerLogin.rejected, (state, action) => {
        state.customerLoginStatus = IDS.SLICESTATUS.Failed;
        state.customerLoginError = action.payload;
      })

      .addCase(forgotPassword.pending, (state) => {
        state.forgotPasswordStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.forgotPasswordStatus = IDS.SLICESTATUS.Succeeded;
        state.forgotPasswordData = action.payload?.data || null;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.forgotPasswordStatus = IDS.SLICESTATUS.Failed;
        state.forgotPasswordError = action.payload;
      })

      .addCase(getUserWalletHistory.pending, (state) => {
        state.getUserWalletHistoryStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(getUserWalletHistory.fulfilled, (state, action) => {
        state.getUserWalletHistoryStatus = IDS.SLICESTATUS.Succeeded;
        state.getUserWalletHistoryData = action.payload?.data || null;
      })
      .addCase(getUserWalletHistory.rejected, (state, action) => {
        state.getUserWalletHistoryStatus = IDS.SLICESTATUS.Failed;
        state.getUserWalletHistoryError = action.payload;
      })

      .addCase(getUserIncomeDetails.pending, (state) => {
        state.getUserIncomeDetailsStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(getUserIncomeDetails.fulfilled, (state, action) => {
        state.getUserIncomeDetailsStatus = IDS.SLICESTATUS.Succeeded;
        state.getUserIncomeDetailsData = action.payload?.data || null;
      })
      .addCase(getUserIncomeDetails.rejected, (state, action) => {
        state.getUserIncomeDetailsStatus = IDS.SLICESTATUS.Failed;
        state.getUserIncomeDetailsError = action.payload;
      });
  },
});

export const { logoutUser } = LoginSlice.actions;
export default LoginSlice.reducer;
